import { render, staticRenderFns } from "./KHeader.vue?vue&type=template&id=11865edd&scoped=true&"
import script from "./KHeader.vue?vue&type=script&lang=js&"
export * from "./KHeader.vue?vue&type=script&lang=js&"
import style0 from "./KHeader.vue?vue&type=style&index=0&id=11865edd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11865edd",
  null
  
)

export default component.exports